import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { selectDoesUserHaveRbacPermission } from 'core/userContext/selectors';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { MEDIA_LAYOUT_ICONS } from 'modules/placements/constants';
import { Placement } from 'modules/placements/types';
import { OverflowMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';
import { Key } from 'constants/keyCodes';
import {
  Description,
  Name,
  PlacementDetails,
  PlacementsListEntryContainer,
  MediaLayoutIconWrapper,
} from './styles';
import { usePlacementsManageContext } from '../../context/PlacementsManageContext';

export const PlacementsListEntry = ({
  placement,
  isSelected,
  onClick,
}: {
  placement: Placement;
  isSelected: boolean;
  onClick: () => void;
}) => {
  const canEditPlacements = useSelector(selectDoesUserHaveRbacPermission)(
    PROJECT_PERMISSIONS.ManageChannelConfiguration,
  );
  const history = useHistory();
  const MediaLayoutIcon = MEDIA_LAYOUT_ICONS[placement.mediaLayout];
  const { openArchiveModal, setIsDisplayPriorityTakeoverOpen } = usePlacementsManageContext();

  const entryOptions = [
    {
      content: 'Make a copy',
      id: 'placement-copy',
      as: AllowedActionMenuElements.Button,
      onClick: () => history.push(`/settings/placements/create?from=${placement.id}`),
    },
    {
      content: 'Archive',
      id: 'placement-archive',
      as: AllowedActionMenuElements.Button,
      onClick: () => openArchiveModal(placement),
    },
    {
      content: 'Edit display priority',
      id: 'placement-display-priority',
      as: AllowedActionMenuElements.Button,
      onClick: () => setIsDisplayPriorityTakeoverOpen(true, placement.id),
    },
  ];

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    // Check if the Enter key is pressed
    if (event.key === Key.ENTER) {
      onClick();
    }
  };

  return (
    <PlacementsListEntryContainer
      onClick={onClick}
      isSelected={isSelected}
      data-test="placement-list-entry"
      tabIndex={0}
      onKeyDown={handleKeyDown}
    >
      <MediaLayoutIconWrapper>{MediaLayoutIcon}</MediaLayoutIconWrapper>
      <PlacementDetails>
        <Name>{placement.placementName}</Name>
        {placement.description && <Description>{placement.description}</Description>}
      </PlacementDetails>
      {!placement.isArchived && canEditPlacements && isSelected && (
        <OverflowMenu id={`action-menu-${placement.id}`} options={entryOptions} />
      )}
    </PlacementsListEntryContainer>
  );
};
